<template>
    <div class="admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="top_filters_area">
        <div class="places_search">
            <b-form-input
                    v-model="search"
                    placeholder="Start typing to search"
                    class="search_places"
            ></b-form-input>
            <div class="places_sort_group">
                <div class="places_sort_by">
                    {{translate('admin_sortBy')}}:
                    <ul>
                        <li>
                            <div class="places_sort_link" @click="placesChangedBy('name')"
                                 :class="{active: this.config.orderBy == 'name'}">
                                {{translate('admin_sortByName')}}
                            </div>
                        </li>
                        <li>
                            <div class="places_sort_link" @click="placesChangedBy('date_added')"
                                 :class="{active: this.config.orderBy == 'date_added'}">
                                {{translate('admin_sortByAdded')}}
                            </div>
                        </li>
                        <li>
                            <div class="places_sort_link" @click="placesChangedBy('date_updated')"
                                 :class="{active: this.config.orderBy == 'date_updated'}">
                                {{translate('admin_sortByUpdated')}}
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="places_sort_dir">
                    Sort dir:
                    <ul>
                        <li>
                            <a class="places_sort_icon" @click="placesChangedDir('asc')"
                               :class="{active: this.config.orderDir == 'asc'}">
                                <i class="fas fa-chevron-up"></i>
                            </a>
                        </li>
                        <li>
                            <a class="places_sort_icon" @click="placesChangedDir('desc')"
                               :class="{active: this.config.orderDir == 'desc'}">
                                <i class="fas fa-chevron-down"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="px-3 pb-3">
            <b-form-checkbox v-model="showAllPlaces">
                <span v-text="translate('admin_showAllPlaces')"></span>
            </b-form-checkbox>
        </div>
        </div>
        <b-list-group class="places_list" id="places_list" @scroll="onListScrolled">

            <b-list-group-item v-for="(item, index) in places" :key="index" :id="`place-${index}`"
                               class="place-item">
                <img class="place_image" :src="item.preview">
                <div class="place_name">
                            <span @click="onPlaceClick(item, `#place-${index}`)"
                                  class="place-title">{{item.name}} | <span>{{item.short_tag}}</span></span>
                    <div>
                        <span class="place-address d-none d-sm-inline" v-if="item.address">Adress:</span> <span
                            class="place-address_info">{{item.address}}</span>
                    </div>
                    <div class="places-managers">
                        <span class="places-managers_title"
                              v-if="item.managers && item.managers.length > 0"
                              @click="item.showManagers = !item.showManagers"><span v-if="item.showManagers">Hide</span><span v-else>Show</span> managers</span>
                        <div v-for="managers in item.managers" :key="managers.guid" v-if="item.showManagers" class="place-manager">
                            {{managers.email}} ({{managers.first_name}} {{managers.last_name}})
                        </div>
                    </div>
                    <div class="places-link">
                        <span class="places-link_title d-none d-sm-inline" v-if="item.links && item.links.length > 0">Links:</span>
                        <div v-for="links in item.links" :key="links.uid" class="places-link_info">
                             <a target="_blank" class="places-link link" :href="links.url">{{links.network.name}}{{links.enabled ? '' : ' (disabled)'}}</a>
                        </div>
                    </div>
                    <div class="configs-btns">
                        <div class="configs-btn" @click="goToSecondLevelDetails(item.uid, item.organization)">
                          SLD config
                        </div>
                        <div class="configs-btn" @click="goToServiceLogConfig(item.uid, item.organization)">
                          SL config
                        </div>
                    </div>
                    <div class="control-panel">
                        <div @click.stop="deletePlaceClick(item)" class="control-panel-item delete-place-icon">
                            <i class="fas fa-trash-alt"></i>
                        </div>
                    </div>

                </div>
            </b-list-group-item>
            <infinite-loading :identifier="infinityValue" @infinite="loadPlacesList">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </b-list-group>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import InfiniteLoading from 'vue-infinite-loading';
    import customModalDialog from "../../widgets/customModalDialog";
    import errorMixin from "@/mixins/errorMixin";
    import adminStickyHeaderMixin from "@/mixins/adminStickyHeaderMixin";
    import adminPageMixin from "@/mixins/adminPageMixin";

    export default {
        mixins: [errorMixin, adminStickyHeaderMixin, adminPageMixin,],
        name: "Places",
        components: {
            InfiniteLoading,
            customModalDialog
        },
        data() {
            return {
                search: '',
                page: 1,
                infinityValue: 0,
                searchTimer: null,
                showAllPlaces: false,
                config: {
                    orderBy: 'date_updated',
                    orderDir: 'desc',
                    get_all: false
                },
                loadingAction: false,
                places: [],
                customModalSettings: {}
            }
        },
        watch: {
            infinity(val) {
                this.page = 1
                this.infinityValue += 1
            },
            showAllPlaces() {
                console.log('work')
                this.page = 1
                this.places = []
                this.infinityValue += 1
            },
            search(value) {
                this.refreshPlaces()
            },
        },
        props: ['infinity'],
        mounted() {
            this.initAdminPage()
        },
        methods: {
            ...mapActions({
                getPlacesList: 'place/getPlacesList',
                deletePlaceAction: 'place/deletePlace',
                connectQuestionToPlaceAdmin: 'question/connectQuestionToPlaceAdmin',
            }),
            ...mapMutations({
                saveScrolledPlace: 'saveScrolledItem',
            }),
            onPlaceClick(item, idToScroll) {
                this.saveScrolledPlace(idToScroll)
                this.$router.push({name: 'QRquestions', params: {id: item.uid}})
            },
            refreshPlaces() {
                if (this.searchTimer) {
                    clearTimeout(this.searchTimer);
                }
                this.searchTimer = setTimeout(() => {
                    this.page = 1
                    this.places = []
                    this.infinityValue += 1
                }, 450);
            },
            async loadPlacesList(stateInf) {
                let data = {
                    search: this.search,
                    order_by: this.config.orderBy,
                    order_dir: this.config.orderDir,
                    get_all: this.showAllPlaces,
                    page: this.page
                }
                try {
                    this.loadingAction = true
                    const response = await this.getPlacesList(data)
                    if (response.success) {
                        if(this.page == 1) {
                            this.places = []
                        }
                        this.page += 1;
                        response.sites.forEach((item) => {
                            item.showManagers = false
                            this.places.push(item)
                        })
                        console.log(this.places)
                        if (stateInf) {
                            if (response.sites.length === 10) {
                                stateInf.loaded();
                            } else {
                                stateInf.complete();
                            }
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.showErrorModal()
                } finally {
                    this.loadingAction = false
                }
            },
            async setPlace(uid) {
                let body = {
                    place_id: uid
                };
                try {
                    const response = await this.connectQuestionToPlaceAdmin({
                        questionId: this.UnlinkedQuestionsUID,
                        body
                    })
                    if (response.data.success) {
                        this.showModal = false;
                        this.ShowDelete = false
                        this.showModalChange = true;
                        this.showConfirmModal(false)
                        this.getListUnlinked();
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.showErrorModal('Error', {title: 'CancelRequest'})
                }
            },
            placesChangedBy(value) {
                this.config.orderBy = value
                this.refreshPlaces()
            },

            placesChangedDir(value) {
                this.config.orderDir = value
                this.refreshPlaces()
            },
            selectPlace(uid, choose, question, location, link) {
                this.unlinkedUID = uid;
                this.question = question;
                this.location = location;
                this.UnlinkPDF = link;
                switch (choose) {
                    case 'place': {
                        this.setPlace(uid)
                        break;
                    }
                    case 'edit': {
                        this.showModalChange = true;
                        break;
                    }
                }
            },
            deletePlaceClick(place) {
                this.customModalSettings = {
                    message: this.translate('admin_deletePlace', [place.name]),
                    secondaryMessage: this.translate('admin_deletePlaceWarning'),
                    onOkHandler: this.deletePlace.bind(null, place),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },

            async deletePlace(place) {
                await this.deletePlaceAction(place)
                this.customModalSettings = {
                    message: this.translate('admin_successMessageRemovePlace'),
                    okButtonText: this.translate('yes'),
                    onOkHandler:  this.refreshPlaces(),
                    icon: 'ic_allow.svg'
                }

            },
            goToSecondLevelDetails(uid, orgUid) {
                this.$router.push({name: 'secondLevelDetailsConfig', params: {uid: uid, orgUid: orgUid}})
                this.$router.go(0)
            },
            goToServiceLogConfig(uid, orgUid) {
                this.$router.push({name: 'serviceLogConfig', params: {uid: uid, orgUid: orgUid}})
                this.$router.go(0)
            },
            onListScrolled(element) {
                this.fixStickyHeader(element.srcElement.scrollTop)
            },
        }
    }
</script>

<style scoped>
    .places_search {
        display: flex;
        display: -ms-flexbox;
        display: -webkit-flex;
    }
    .search_places {
        width: 350px;
        margin-bottom: 7px;
        margin-left: 12px;
    }

    .places_sort_group {
        display: flex;
        display: -ms-flexbox;
        display: -webkit-flex;
    }

    .place_image {
        width: 70px !important;
        height: 70px !important;
        margin-bottom: 5px;
    }

    .place_name {
        margin-left: 10px;
        width: 100%;
        padding-right: 30px;
        line-height: 17px;
    }

    .place-title {
        display: block;
        padding-right: 40px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-weight: 700;
        padding-bottom: 4px;
        cursor: pointer;
    }

    .place-uid {
        font-weight: 700;
    }

    .place-address {
        font-weight: 700;
        padding-right: 5px;
    }

    .place-organization {
        font-weight: 700;
        padding-right: 5px;
    }

    .places-managers {
        display: flex;
        flex-direction: column;
        display: -ms-flexbox;
        display: -webkit-flex;
        -webkit-flex-direction: row;
        -ms-flex-direction: row;
    }

    .places-managers_title {
        margin-top: 4px;
        margin-bottom: 4px;
        color: black;
        cursor: pointer;
        background: #e7e7e7;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 5px;
        width: max-content;
    }
    .places-managers_title:hover {
        background: #5e5e5e;
        color: white;
    }

    .place-manager:last-child {
        margin-bottom: 8px;
    }

    .places-link {
        display: flex;
        flex-direction: row;
        display: -ms-flexbox;
        display: -webkit-flex;
        -webkit-flex-direction: row;
        -ms-flex-direction: row;
    }
    .places-link.link {
        color: #007bff !important;
    }

    .places-link_title {
        padding-right: 5px;
        font-weight: 700;
    }

    .places-link_info {
        padding-right: 5px;
    }

    .places_search {
        display: flex;
        display: -ms-flexbox;
        display: -webkit-flex;
    }

    .places_sort_by {
        display: flex;
        display: -ms-flexbox;
        display: -webkit-flex;
        padding-top: 7px;
        padding-left: 20px;
    }

    .places_sort_dir {
        display: flex;
        display: -ms-flexbox;
        display: -webkit-flex;
        padding-top: 7px;
        padding-left: 20px;
    }

    .places_sort_icon {
        height: 20px;
        color: black;
        margin-left: 10px;
        cursor: pointer;
    }

    .places_sort_icon.active {
        border: 2px solid black;
        border-radius: 5px;
        padding: 5px;
    }

    .places_sort_link {
        cursor: pointer;
    }

    .places_sort_link.active {
        border-bottom: 2px solid black;
    }

    .place-title:hover {
        opacity: 0.65;
    }

    .place_uid {
        font-size: 14px;
        width: 100%;
        overflow: hidden;
    }
    .delete-place-icon {
        width: 30px;
        height: 30px;
        align-items: center;
        justify-content: flex-end;
    }
    .list-group-item {
         display: flex;
         align-items: center;
         transition: all 0.15s ease;
         display: -ms-flexbox;
         display: -webkit-flex;
    }
    .list-group-item .place_rate {
        width: 3.5em;
        transform: scale(1.9);
    }
    .places_list {
        max-height: calc(100vh - 62px);
        overflow: auto;
        margin-bottom: 0;
        padding-bottom: 5em;
    }
    .configs-btns {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
    .configs-btn {
        margin-top: 6px;
        color: black;
        cursor: pointer;
        background: #e7e7e7;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 5px;
    }
    .configs-btn:hover {
        background: #5e5e5e;
        color: white;
    }
    .place-item {
        border-bottom: none;
    }

    @media screen and (max-width: 1403px) {
        .places_sort_by {
            padding-top: 7px;
        }

        .places_sort_dir {
            padding-top: 7px;
        }

        .place-item {
            margin-bottom: 0px;
            padding: 5px 20px 10px 4px;
        }
    }
    @media screen and (max-width: 1102px) {
        .places_search {
            display: flex;
            flex-direction: column;
            display: -ms-flexbox;
            display: -webkit-flex;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
        }

        .search_places {
            width: calc(100% - 24px);
            margin-right: 12px;
        }

        .place-item {
            margin-bottom: 0px;
            padding: 5px 20px 10px 4px;
        }
    }
    @media screen and (max-width: 1000px) {
        .list-group-item img {
            width: 45px;
            height: 45px;
        }
        .place-item {
            font-size: 12px;
            margin-bottom: 0px;
        }

        .place_uid {
            font-size: 12px;
        }
    }
    @media screen and (max-width: 660px) {
        .place_image {
            width: 55px;
            height: 55px;
            margin-left: 8px;
        }

        .place-item {
            font-size: 10px;
        }
    }

    @media screen and (max-width: 503px) {
        .places_sort_group {
            display: flex;
            flex-direction: column;
            display: -ms-flexbox;
            display: -webkit-flex;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
        }
    }
</style>
